import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./common";
import { wa } from "../lib/site";

export default function Team() {
    const { lang, t } = useLang();
    const msg =
        lang === "pt"
            ? "Olá! Vim pelo site da ANG e gostaria de falar com a equipe."
            : "Hi! I came from the ANG website and would like to talk to the team.";

    return (
        <section
            id="equipe"
            data-testid="team-section"
            className="relative py-24 md:py-32 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-[1.25fr_0.75fr] gap-12 items-center">
                <Reveal>
                    <div className="relative clip-notch border border-white/10">
                        <img
                            src="/obras/equipe.webp"
                            alt="Equipe responsável da ANG em campo"
                            className="w-full h-[340px] md:h-[500px] object-cover contrast-[1.05]"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-obsidian/85 via-transparent to-transparent pointer-events-none" />
                        <div className="absolute top-0 right-0 w-14 h-14 border-t-2 border-r-2 border-volt" />
                        <div className="absolute bottom-0 left-0 w-14 h-14 border-b-2 border-l-2 border-volt" />
                        <span className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-200 bg-obsidian/80 backdrop-blur border border-volt/30 rounded-lg px-3.5 py-2">
                            {t.team.badge}
                        </span>
                    </div>
                </Reveal>

                <Reveal delay={0.15}>
                    <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
                        {t.team.title}
                    </h2>
                    <p className="mt-5 text-slate-400 leading-relaxed">
                        {t.team.sub}
                    </p>
                    <a
                        data-testid="team-whatsapp-cta"
                        href={wa(msg)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-9 inline-flex items-center gap-3 bg-volt text-obsidian font-bold px-7 py-4 rounded-full hover:shadow-[0_0_40px_rgba(255,230,0,0.45)] hover:-translate-y-0.5 transition-all"
                    >
                        <MessageCircle className="w-5 h-5" />
                        {t.team.cta}
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
